"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorDefinitions = exports.messages = void 0;

var _reactIntl = require("react-intl");

var messages = (0, _reactIntl.defineMessages)({
  anUnexpectedErrorHasOccurred: {
    "id": "An unexpected error has occurred.",
    "defaultMessage": "An unexpected error has occurred."
  },
  anUnexpectedApiErrorHasOccurred: {
    "id": "An unexpected API error has occurred.",
    "defaultMessage": "An unexpected API error has occurred."
  },
  unrecognizedApiResponse: {
    "id": "Unrecognized API response.",
    "defaultMessage": "An unexpected API error has occurred."
  },
  anUnexpectedHttpErrorHasOccurred: {
    "id": "An unexpected HTTP error has occurred.",
    "defaultMessage": "An unexpected API error has occurred."
  },
  anUnexpectedWebsocketErrorHasOccurred: {
    "id": "An unexpected WebSocket error has occurred.",
    "defaultMessage": "An unexpected API error has occurred."
  },
  unableToImportMissingRequiredElement: {
    "id": "Unable to import, missing required element: [[ msg_missing_element ]]",
    "defaultMessage": "An unexpected API error has occurred."
  },
  networkErrorOccurred: {
    "id": "network.error.occurred",
    "defaultMessage": "There were some network problems during this operation."
  }
});
exports.messages = messages;
var errorDefinitions = [{
  type: 'com.kistler.paramman.serializer.error',
  subType: 'skybase::paramman::MissingElementException',
  message: messages.unableToImportMissingRequiredElement
}];
exports.errorDefinitions = errorDefinitions;
//# sourceMappingURL=messages-i18n.js.map